import React from "react";
import { ContainerRequestList } from "../shared/MainStyles";
import RequestList from "./RequestList";
import { RequestHeader } from "./Slogan";


export function HomeRequest() {
  return (
    <>
         <RequestHeader showButton />
        <ContainerRequestList>
              <RequestList />
        </ContainerRequestList>
    </>
  );
}
